import { lazy, Suspense, type ComponentProps } from 'react';

// Lazy boundary for Lottie. @lottiefiles/dotlottie-react (~657KB) only renders for
// niche animations (audio waveforms, product tours) and is never on first paint of
// a workflow, yet it was statically imported into the editor's cold-boot path.
// Splitting it loads the lib only when an animation actually renders. The named
// `LottieAnimation` export is preserved so callers are unchanged.
const LottieAnimationImpl = lazy(() => import('./LottieAnimationImpl'));

export const LottieAnimation = (props: ComponentProps<typeof LottieAnimationImpl>) => (
  <Suspense fallback={null}>
    <LottieAnimationImpl {...props} />
  </Suspense>
);
